// Closing a season (24.7): record end-of-season numbers, move the report into history, clear
// this season's answers and advance the clock (Section 4: four seasons per year).
import { RESOURCES } from '../../core/constants';
import { countIds } from '../../core/sorted';
import type { PhaseContext, Resource } from '../../core/types';

export function closeSeason(ctx: PhaseContext): void {
  const d = ctx.draft;
  const report = ctx.report.current;
  report.population.end = countIds(d.people);
  const end = {} as Record<Resource, number>;
  for (const r of RESOURCES) end[r] = d.stocks[r].amount;
  report.stocksEnd = end;
  d.history.push(report);
  d.currentReport = null;
  d.promptAnswers = {};
  const order = ctx.cfg.seasons.order;
  const next = (order.indexOf(d.season) + 1) % order.length;
  d.season = order[next] ?? d.season;
  if (next === 0) d.year += 1;
}
